interface IInput {
  className?: string;
  placeholder?: string;
  name?: string;
  label?: string;
  style?: string;
  value?: string | number | readonly string[];
  accept?: string;
  imageNames?: string[];
  multiple?: boolean;
  // onChange: ChangeEventHandler<HTMLInputElement>
  onChange?: (e: any) => void;
}

const InputFile: React.FC<IInput> = ({
  className = '',
  placeholder,
  name,
  style,
  onChange,
  value,
  accept,
  label,
  imageNames,
  multiple = false,
}) => {
  return (
    <div className={`flex ${style}`}>
      <label className="rounded-md border-2 border-neutra3-cinzaquente30 bg-neutra3-cinzaquente60 px-3 py-2 text-center text-neutra3-cinzaquente10 hover:cursor-pointer">
        {label}
        <input
          name={name}
          type="file"
          accept={accept}
          className={`w-full border-none bg-transparent py-1 pl-2 pr-4 text-xs placeholder:text-neutra3-cinzaquente50 focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-neutra3-cinzaquente50 ${className}`}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          multiple={multiple}
          hidden
        />
      </label>
      {imageNames?.map(name => <p key={name}>{name}</p>)}
      {/* <label htmlFor={indentifier}></label> */}
    </div>
  );
};

export default InputFile;
